// eslint-disable-next-line import/no-extraneous-dependencies
import { gtag, install } from 'ga-gtag';

const userTypes = {
  1: 'Fund',
  2: 'Investor',
  3: 'Service Provider',
  4: 'iConnections',
  5: 'Speaker',
  6: 'Guest',
  7: 'Media',
  8: 'Other',
  9: 'NFT',
  10: 'Student/Retired',
};

const sendEvent = (event, payload) => {
  if (!process.env.GOOGLE_ANALYTICS_KEY) { return; }
  gtag('event', event, payload);
};

const init = (userInfo) => {
  if (!process.env.GOOGLE_ANALYTICS_KEY) { return; }
  install(process.env.GOOGLE_ANALYTICS_KEY, { send_page_view: false, debug_mode: process.env.DEBUG });

  // Initialize the user
  gtag('config', process.env.GOOGLE_ANALYTICS_KEY, {
    contact_id: userInfo.id,
    company_id: userInfo.CompanyID,
    company_type_id: userInfo.CompanyTypeID,
    company_name: userInfo.CompanyName,
    user_type: userTypes[userInfo.CompanyTypeID],
    subscriber: typeof userInfo.Subscriber === 'string' ? userInfo.Subscriber === 'true' : userInfo.Subscriber,
  });
};

// Identify the user
const identify = (userInfo) => {
  if (!process.env.GOOGLE_ANALYTICS_KEY) { return; }
  gtag('set', 'user_properties', {
    contact_id: userInfo.id,
    company_id: userInfo.CompanyID,
    company_type_id: userInfo.CompanyTypeID,
    company_name: userInfo.CompanyName,
    user_type: userTypes[userInfo.CompanyTypeID],
    subscriber: typeof userInfo.Subscriber === 'string' ? userInfo.Subscriber === 'true' : userInfo.Subscriber,
  });
};

export default {
  sendEvent,
  init,
  identify,
};
